import { render } from "./DetailsTags.vue?vue&type=template&id=371fe6a5&scoped=true&ts=true"
import script from "./DetailsTags.vue?vue&type=script&lang=ts"
export * from "./DetailsTags.vue?vue&type=script&lang=ts"

import "./DetailsTags.vue?vue&type=style&index=0&id=371fe6a5&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371fe6a5"]])

export default __exports__